<template>
  <transition name="fade">
    <div v-if="value" class="dark-overlay v-centerer modal" @click="close(false, $event)">
      <div class="dark-overlay-content" :class="contentClasses" @click.stop="">
        <CloseButton absolute @click.native="close(false)" />
        <div class="content-wrapper">
          <div class="modal__scroller">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * Display content of a slot into an overlay div with a fade transition
 * Basically, almost all occurrences of <dark-overlay><dark-overlay-content> should
 * be replaced with a 'Modal' component
 *
 * @vue-prop {Boolean} [stopPropagation] - When clicking outside the modal, choose to stop propagation or not
 */

import $ from 'jquery';
// Components
import CloseButton from '@/components/close-button.vue';

export default {

  name: 'Modal',

  components: {
    CloseButton,
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    small: Boolean,
    large: Boolean,
    xlarge: Boolean,
    fullscreen: Boolean,
    stopPropagation: Boolean,
  },

  computed: {
    contentClasses() {
      return {
        small: this.small,
        large: this.large,
        xlarge: this.xlarge,
        fullscreen: this.fullscreen,
      };
    },
  },

  watch: {
    value(displayed) {
      if (displayed) {
        $(document).on(this.escKeyupEventName, () => { this.close(true); });
      } else {
        $(document).off(this.escKeyupEventName);
      }
    },
  },

  mounted() {
    if (this.value) {
      $(document).on(this.escKeyupEventName, () => { this.close(true); });
    }
  },

  beforeDestroy() {
    $(document).off(this.escKeyupEventName);
  },

  methods: {
    close(fromEscKey, evt) {
      if (!fromEscKey) {
        $(document).off(this.escKeyupEventName);
      }
      if (this.stopPropagation && evt) {
        evt.stopPropagation();
      }
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.modal.dark-overlay {
  .dark-overlay-content {
    padding: 0px;
    border-radius: $main-border-radius;

    > .content-wrapper {
      height: 100%;

      > .modal__scroller {
        height: 100%;
        overflow: auto;
      }
    }
  }
}
</style>
